import React from "react";
import styles from './aboutPage.component.less';
import aboutMePhoto from '../../../images/PersonalwwwAboutMePhoto.png';
import imgHiImBurhan from '../../../images/burhan.png';
function AboutPage(props)
{
    return (
        <div className={styles.about}>
           <div>
                <img src={aboutMePhoto} alt="" />
           </div>
           <div>
            <img src={imgHiImBurhan} alt="" id={styles.hi}/>
            <p dangerouslySetInnerHTML={{__html: props.aboutText}}>
            </p>
           </div>
        </div>
    );
}

export default AboutPage;